import type { MemberProfileMapCoords } from '@library/types/memberProfileMap';
import { getMemberDateTime } from '@bo-utils/members/memberCommon';

export interface MemberProfileLocationTableRowProps {
  data: MemberProfileMapCoords;
}

export const MemberProfileLocationTableRow = ({
  data
}: MemberProfileLocationTableRowProps) => {
  const {
    city,
    country,
    createdAt,
    id,
    ipAddress,
    latitude,
    longitude,
    state
  } = data;

  const { date: createdDate, time: createdTime } = getMemberDateTime(createdAt);

  return (
    <div className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 group/user text-2xs relative flex items-center border-b xl:text-xs">
      <p className="flex w-[12.5%] p-3">{id}</p>
      <p className="flex w-[15%] break-all p-3 pr-8">{ipAddress}</p>
      <p className="flex w-[10%] p-3">{latitude}</p>
      <p className="flex w-[12.5%] p-3">{longitude}</p>
      <p className="flex w-[12.5%] p-3">{city}</p>
      <p className="flex w-[12.5%] p-3">{state}</p>
      <p className="flex w-[12.5%] p-3">{country}</p>
      <p className="flex w-[12.5%] flex-col p-3">
        <span className="leading-5">{createdDate}</span>
        <span className="text-soClean-160">{createdTime}</span>
      </p>
    </div>
  );
};
